import { render, staticRenderFns } from "./SuorganizatorCreate.vue?vue&type=template&id=52f31e0f&scoped=true&"
import script from "./SuorganizatorCreate.vue?vue&type=script&lang=js&"
export * from "./SuorganizatorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f31e0f",
  null
  
)

export default component.exports